import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Footer } from '../../components/Footer';
import { Star, MapPin, Calendar, Shield, TrendingUp, Award, MessageCircle } from 'lucide-react';
import { StarRating } from '../../components/StarRating';
export function SellerProfilePage() {
  const {
    id
  } = useParams();
  const sellerProfile = {
    name: 'Rajesh Kumar',
    initials: 'RK',
    memberSince: '2022-03-15',
    location: 'Pune, Maharashtra',
    verificationStatus: 'verified',
    overallRating: 4.8,
    totalReviews: 24,
    totalSales: 8,
    responseTime: '2 hours',
    responseRate: '98%'
  };
  const listings = [{
    id: 1,
    title: 'Premium Corner Plot in Hinjewadi Phase 1',
    price: '₹45 Lakhs',
    size: '2400 sq ft',
    location: 'Hinjewadi, Pune',
    status: 'Active',
    views: 245
  }, {
    id: 2,
    title: 'Residential Plot near Metro Station',
    price: '₹38 Lakhs',
    size: '2000 sq ft',
    location: 'Baner, Pune',
    status: 'Active',
    views: 189
  }, {
    id: 3,
    title: 'Commercial Land on Main Road',
    price: '₹1.2 Cr',
    size: '5000 sq ft',
    location: 'Kharadi, Pune',
    status: 'Sold',
    views: 456
  }];
  const reviews = [{
    id: 1,
    buyerName: 'Amit Sharma',
    buyerInitials: 'AS',
    rating: 5,
    date: '2024-01-15',
    property: 'Plot in Wakad',
    comment: 'Excellent seller! Very transparent and cooperative throughout the process. All documents were genuine and verified.'
  }, {
    id: 2,
    buyerName: 'Priya Patel',
    buyerInitials: 'PP',
    rating: 5,
    date: '2024-01-10',
    property: 'Land in Hinjewadi',
    comment: 'Highly recommend! Clear communication and fair pricing. The property was exactly as described.'
  }, {
    id: 3,
    buyerName: 'Rohan Gupta',
    buyerInitials: 'RG',
    rating: 4,
    date: '2023-12-20',
    property: 'Plot in Baner',
    comment: 'Good experience overall. Minor delays in documentation but seller was helpful in resolving issues.'
  }];
  const ratingDistribution = {
    5: 18,
    4: 4,
    3: 1,
    2: 1,
    1: 0
  };
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-5360">
      {/* Header */}
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-5361">
        <Link to="/" className="flex items-center gap-2" data-id="element-5362">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-5363"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-5364">
            Citiplots.com
          </span>
        </Link>
      </header>

      <main className="flex-1 max-w-6xl mx-auto px-6 py-12" data-id="element-5365">
        {/* Breadcrumb */}
        <div className="mb-6" data-id="element-5366">
          <Link to="/" className="text-sm text-gray-600 hover:text-gray-900" data-id="element-5367">
            Home
          </Link>
          <span className="text-sm text-gray-400 mx-2" data-id="element-5368">/</span>
          <span className="text-sm text-gray-900" data-id="element-5369">Seller Profile</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-5370">
          {/* Left Column - Seller Info */}
          <div className="lg:col-span-1 space-y-6" data-id="element-5371">
            {/* Profile Card */}
            <div className="bg-white border border-gray-300 p-6" data-id="element-5372">
              <div className="flex flex-col items-center text-center mb-6" data-id="element-5373">
                <div className="w-24 h-24 bg-gray-200 rounded-full flex items-center justify-center text-3xl font-bold mb-4" data-id="element-5374">
                  {sellerProfile.initials}
                </div>
                <h1 className="text-2xl font-bold mb-2" data-id="element-5375">
                  {sellerProfile.name}
                </h1>
                {sellerProfile.verificationStatus === 'verified' && <div className="flex items-center gap-2 px-3 py-1 bg-green-50 border border-green-200 text-green-700 text-xs font-bold rounded" data-id="element-5376">
                    <Shield className="w-4 h-4" data-id="element-5377" />
                    VERIFIED SELLER
                  </div>}
              </div>

              <div className="space-y-3 text-sm" data-id="element-5378">
                <div className="flex items-center gap-2 text-gray-600" data-id="element-5379">
                  <MapPin className="w-4 h-4" data-id="element-5380" />
                  <span data-id="element-5381">{sellerProfile.location}</span>
                </div>
                <div className="flex items-center gap-2 text-gray-600" data-id="element-5382">
                  <Calendar className="w-4 h-4" data-id="element-5383" />
                  <span data-id="element-5384">
                    Member since{' '}
                    {new Date(sellerProfile.memberSince).toLocaleDateString('en-US', {
                    month: 'short',
                    year: 'numeric'
                  })}
                  </span>
                </div>
              </div>

              <button className="w-full mt-6 py-3 bg-[#1f2933] text-white font-bold hover:bg-gray-800" data-id="element-5385">
                Contact Seller
              </button>
            </div>

            {/* Stats Card */}
            <div className="bg-white border border-gray-300 p-6" data-id="element-5386">
              <h3 className="font-bold mb-4" data-id="element-5387">Seller Statistics</h3>
              <div className="space-y-4" data-id="element-5388">
                <div className="flex items-center justify-between pb-3 border-b border-gray-200" data-id="element-5389">
                  <span className="text-sm text-gray-600" data-id="element-5390">Overall Rating</span>
                  <div className="flex items-center gap-2" data-id="element-5391">
                    <StarRating rating={sellerProfile.overallRating} size="sm" data-id="element-5392" />
                  </div>
                </div>
                <div className="flex items-center justify-between pb-3 border-b border-gray-200" data-id="element-5393">
                  <span className="text-sm text-gray-600" data-id="element-5394">Total Reviews</span>
                  <span className="font-bold" data-id="element-5395">
                    {sellerProfile.totalReviews}
                  </span>
                </div>
                <div className="flex items-center justify-between pb-3 border-b border-gray-200" data-id="element-5396">
                  <span className="text-sm text-gray-600" data-id="element-5397">
                    Successful Sales
                  </span>
                  <span className="font-bold" data-id="element-5398">{sellerProfile.totalSales}</span>
                </div>
                <div className="flex items-center justify-between pb-3 border-b border-gray-200" data-id="element-5399">
                  <span className="text-sm text-gray-600" data-id="element-5400">Response Time</span>
                  <span className="font-bold text-green-600" data-id="element-5401">
                    {sellerProfile.responseTime}
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-5402">
                  <span className="text-sm text-gray-600" data-id="element-5403">Response Rate</span>
                  <span className="font-bold text-green-600" data-id="element-5404">
                    {sellerProfile.responseRate}
                  </span>
                </div>
              </div>
            </div>

            {/* Badges */}
            <div className="bg-white border border-gray-300 p-6" data-id="element-5405">
              <h3 className="font-bold mb-4" data-id="element-5406">Achievements</h3>
              <div className="grid grid-cols-2 gap-3" data-id="element-5407">
                <div className="p-3 border border-gray-200 text-center" data-id="element-5408">
                  <Award className="w-6 h-6 text-yellow-600 mx-auto mb-2" data-id="element-5409" />
                  <p className="text-xs font-bold" data-id="element-5410">Top Seller</p>
                </div>
                <div className="p-3 border border-gray-200 text-center" data-id="element-5411">
                  <TrendingUp className="w-6 h-6 text-blue-600 mx-auto mb-2" data-id="element-5412" />
                  <p className="text-xs font-bold" data-id="element-5413">Fast Response</p>
                </div>
                <div className="p-3 border border-gray-200 text-center" data-id="element-5414">
                  <Shield className="w-6 h-6 text-green-600 mx-auto mb-2" data-id="element-5415" />
                  <p className="text-xs font-bold" data-id="element-5416">Verified Docs</p>
                </div>
                <div className="p-3 border border-gray-200 text-center" data-id="element-5417">
                  <Star className="w-6 h-6 text-purple-600 mx-auto mb-2" data-id="element-5418" />
                  <p className="text-xs font-bold" data-id="element-5419">5-Star Rated</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Listings & Reviews */}
          <div className="lg:col-span-2 space-y-6" data-id="element-5420">
            {/* Active Listings */}
            <div className="bg-white border border-gray-300 p-6" data-id="element-5421">
              <h2 className="font-bold text-xl mb-6" data-id="element-5422">
                Active Listings (
                {listings.filter(l => l.status === 'Active').length})
              </h2>
              <div className="space-y-4" data-id="element-5423">
                {listings.filter(l => l.status === 'Active').map(listing => <div key={listing.id} className="border border-gray-200 p-4 hover:bg-gray-50" data-id="element-5424">
                      <div className="flex items-start justify-between mb-2" data-id="element-5425">
                        <div className="flex-1" data-id="element-5426">
                          <Link to={`/listing/${listing.id}`} className="font-bold hover:text-blue-600" data-id="element-5427">
                            {listing.title}
                          </Link>
                          <p className="text-sm text-gray-600 flex items-center gap-1 mt-1" data-id="element-5428">
                            <MapPin className="w-3 h-3" data-id="element-5429" />
                            {listing.location}
                          </p>
                        </div>
                        <div className="text-right" data-id="element-5430">
                          <p className="font-bold text-lg" data-id="element-5431">{listing.price}</p>
                          <p className="text-xs text-gray-500" data-id="element-5432">
                            {listing.size}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center gap-4 text-xs text-gray-500 mt-3" data-id="element-5433">
                        <span data-id="element-5434">
                          Status:{' '}
                          <span className="text-green-600 font-bold" data-id="element-5435">
                            {listing.status}
                          </span>
                        </span>
                        <span data-id="element-5436">Views: {listing.views}</span>
                      </div>
                    </div>)}
              </div>
            </div>

            {/* Reviews Section */}
            <div className="bg-white border border-gray-300 p-6" data-id="element-5437">
              <h2 className="font-bold text-xl mb-6" data-id="element-5438">Reviews & Ratings</h2>

              {/* Rating Summary */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 p-6 bg-gray-50 border border-gray-200" data-id="element-5439">
                <div className="flex flex-col items-center justify-center" data-id="element-5440">
                  <div className="text-5xl font-bold text-[#1f2933] mb-2" data-id="element-5441">
                    {sellerProfile.overallRating}
                  </div>
                  <StarRating rating={sellerProfile.overallRating} size="lg" showNumber={false} data-id="element-5442" />
                  <p className="text-sm text-gray-500 mt-2 font-mono" data-id="element-5443">
                    Based on {sellerProfile.totalReviews} reviews
                  </p>
                </div>

                <div className="space-y-2" data-id="element-5444">
                  {[5, 4, 3, 2, 1].map(rating => {
                  const count = ratingDistribution[rating as keyof typeof ratingDistribution];
                  const percentage = count / sellerProfile.totalReviews * 100;
                  return <div key={rating} className="flex items-center gap-3" data-id="element-5445">
                        <span className="text-sm font-medium w-8" data-id="element-5446">
                          {rating}★
                        </span>
                        <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-5447">
                          <div className="h-full bg-yellow-500" style={{
                        width: `${percentage}%`
                      }} data-id="element-5448"></div>
                        </div>
                        <span className="text-xs text-gray-500 w-12 text-right font-mono" data-id="element-5449">
                          {count}
                        </span>
                      </div>;
                })}
                </div>
              </div>

              {/* Individual Reviews */}
              <div className="space-y-4" data-id="element-5450">
                {reviews.map(review => <div key={review.id} className="border border-gray-200 p-4" data-id="element-5451">
                    <div className="flex items-start gap-3 mb-3" data-id="element-5452">
                      <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-5453">
                        {review.buyerInitials}
                      </div>
                      <div className="flex-1" data-id="element-5454">
                        <div className="flex items-center justify-between mb-1" data-id="element-5455">
                          <div data-id="element-5456">
                            <p className="font-bold text-sm" data-id="element-5457">
                              {review.buyerName}
                            </p>
                            <p className="text-xs text-gray-500" data-id="element-5458">
                              Purchased: {review.property}
                            </p>
                          </div>
                          <span className="text-xs text-gray-500 font-mono" data-id="element-5459">
                            {review.date}
                          </span>
                        </div>
                        <StarRating rating={review.rating} size="sm" showNumber={false} data-id="element-5460" />
                      </div>
                    </div>
                    <p className="text-sm text-gray-700 leading-relaxed" data-id="element-5461">
                      {review.comment}
                    </p>
                  </div>)}
              </div>
            </div>

            {/* Past Sales */}
            <div className="bg-white border border-gray-300 p-6" data-id="element-5462">
              <h2 className="font-bold text-xl mb-6" data-id="element-5463">Past Sales</h2>
              <div className="space-y-4" data-id="element-5464">
                {listings.filter(l => l.status === 'Sold').map(listing => <div key={listing.id} className="border border-gray-200 p-4 bg-gray-50" data-id="element-5465">
                      <div className="flex items-start justify-between mb-2" data-id="element-5466">
                        <div className="flex-1" data-id="element-5467">
                          <p className="font-bold" data-id="element-5468">{listing.title}</p>
                          <p className="text-sm text-gray-600 flex items-center gap-1 mt-1" data-id="element-5469">
                            <MapPin className="w-3 h-3" data-id="element-5470" />
                            {listing.location}
                          </p>
                        </div>
                        <div className="text-right" data-id="element-5471">
                          <p className="font-bold text-lg" data-id="element-5472">{listing.price}</p>
                          <p className="text-xs text-gray-500" data-id="element-5473">
                            {listing.size}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center gap-4 text-xs text-gray-500 mt-3" data-id="element-5474">
                        <span className="px-2 py-1 bg-gray-200 text-gray-700 font-bold" data-id="element-5475">
                          SOLD
                        </span>
                        <span data-id="element-5476">Total Views: {listing.views}</span>
                      </div>
                    </div>)}
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-5477" />
    </div>;
}